<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        แก้ไขคำถามที่พบบ่อย
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-dashboard"></i> จัดการคำถามที่พบบ่อย
          </a>
        </li>
        <li class="active">จัดการคำถามที่พบบ่อย</li>
      </ol>
    </section>

    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12">
            <div class="box">
              <div class="box-header">
                <!-- <h3 class="box-title">Hover Data Table</h3> -->
                <div class="wrapper_addtypegroup">
                  <el-form
                    size="mini"
                    :label-position="label_position"
                    label-width="150px"
                    ref="ruleForm"
                    class="demo-ruleForm"
                  >
                    <div class="row">
                      <div class="col-xs-6">
                        <el-form size="mini">
                          <el-form-item label="คำถาม (Thai)" required>
                            <el-input placeholder="กรุณากรอกข้อมูล" v-model="form.question_th" type="textarea" :rows="5"></el-input>
                          </el-form-item>
                          <el-form-item label="คำถาม (Eng)" required>
                            <el-input placeholder="กรุณากรอกข้อมูล" v-model="form.question_en" type="textarea" :rows="5"></el-input>
                          </el-form-item>
                          <el-form-item label="คำตอบ (Thai)" required>
                            <el-input
                              type="textarea"
                              placeholder="กรุณากรอกข้อมูล"
                              :rows="10"
                              v-model="form.ans_th"
                            ></el-input>
                          </el-form-item>
                          <el-form-item label="คำตอบ (Eng)" required>
                            <el-input
                              type="textarea"
                              :rows="10"
                              placeholder="กรุณากรอกข้อมูล"
                              v-model="form.ans_en"
                            ></el-input>
                          </el-form-item>
                          <el-form-item label="สถานะการแสดงผล">
                            <el-radio-group v-model="form.status" size="small">
                              <el-radio :label="1">แสดง</el-radio>
                              <el-radio :label="0">ไม่แสดง</el-radio>
                            </el-radio-group>
                          </el-form-item>
                        </el-form>
                      </div>
                    </div>
                    <div class="box-footer">
                      <el-button style="float: left;" @click.prevent="back()">ยกเลิก</el-button> <el-button type="primary" style="float: right;" @click="submitForm()">บันทึก</el-button>
                    </div>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
    <!-- /.content -->
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      label_position: "top",
      form: {
        question_th: "",
        question_en: "",
        ans_th: "",
        ans_en: "",
        status: "",
        faq_id: ""
      }
    };
  },
  created() {
    this.$store.dispatch('questionStore/getQuestion', this.$route.query)
  },
  computed: {
    ...mapState({
      current_faq: store => store.questionStore.current_faq
    })
  },
  mounted() {
    this.form.status = this.current_faq.visible_status;
    this.form.question_th = this.current_faq.question_th;
    this.form.question_en = this.current_faq.question_en;
    this.form.ans_en = this.current_faq.answer_en;
    this.form.ans_th = this.current_faq.answer_th;
    this.form.faq_id = this.current_faq.faq_id;
  },
  watch: {
    current_faq: {
      handler : function(reload, empty) {
        let current_faq = reload
        this.form.status = current_faq.visible_status;
        this.form.question_th = current_faq.question_th;
        this.form.question_en = current_faq.question_en;
        this.form.ans_en = current_faq.answer_en;
        this.form.ans_th = current_faq.answer_th;
        this.form.faq_id = current_faq.faq_id;
      }
    }
  },
  methods: {
    ...mapActions({
      editQuestion: "questionStore/editQuestion"
    }),
    submitForm() {
      let submit_form = this.form
      submit_form.admin_id = this.$cookies.get("user_nbtc").admin_id
      this.editQuestion(submit_form);
    },
    back() {
      this.$router.push({ name: 'Manage_question' })
    }
  }
};
</script>
